import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const totalValue: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursement-value`),
};

export default totalValue;
